import { awardsAPI } from "../services/api";

// Awards data service - fetches from backend API
export const getAwards = async () => {
  const response = await awardsAPI.getAll();
  return response.data || [];
};

// Get recent awards (last 3)
export const getRecentAwards = async () => {
  const response = await awardsAPI.getRecent();
  return response.data || [];
};
